'use client'

import s from './page.module.scss';
import {Title} from "@/app/[locale]/common/components/Title/Title";
import {Container} from "@/app/[locale]/common/components/Container/Container";
import {Breadcrumbs} from "@/app/[locale]/common/components/Breadcrumbs/Breadcrumbs";
import Image from "next/image";
import main from '@/app/[locale]/common/assets/images/slider-main/slide_4.webp';
import React from "react";
import {ContactUs} from "@/app/[locale]/common/components/ContactUs/ContactUs";
import {TTasksCardContent, TUserCardContent} from "@/app/[locale]/industries/types";
import {TaskCard} from "@/app/[locale]/common/components/TaskCard/TaskCard";
import {ParagraphLine} from "@/app/[locale]/common/components/ParagraphLine/ParagraphLine";
import {ConfirmIcon} from "@/app/[locale]/common/assets/ConfirmIcon/ConfirmIcon";
import telematics_hardware from '../../common/assets/images/industires/agriculture/telematics-hardware.webp';
import {TitleImageSection} from "@/app/[locale]/common/components/TitleImageSection/TitleImageSection";
import {SliderBlock} from "@/app/[locale]/common/components/SliderBlock/SliderBlock";
import {DieselGeneratorSlideCard} from "@/app/[locale]/common/components/DieselGeneratorSlideCard/DieselGeneratorSlideCard";
import {TDieselGeneratorSlideCardProps} from "@/app/[locale]/common/components/DieselGeneratorSlideCard/types";
import {useTranslations} from "next-intl";
import {DataMonitoringIcon} from "@/app/[locale]/common/assets/DataMonitoringIcon/DataMonitoringIcon";
import {EngineIcon} from "@/app/[locale]/common/assets/EngineIcon/EngineIcon";
import {RemoteManagementIcon} from "@/app/[locale]/common/assets/RemoteManagementIcon/RemoteManagementIcon";
import {FuelIcon} from "@/app/[locale]/common/assets/FuelIcon/FuelIcon";
import slide1 from "@/app/[locale]/common/assets/images/industires/diesel-generators/slider/slide-1.webp";
import slide2 from "@/app/[locale]/common/assets/images/industires/diesel-generators/slider/slide-2.webp";
import slide3 from "@/app/[locale]/common/assets/images/industires/diesel-generators/slider/slide-3.webp";
import {
    addDataToTranslatedArray
} from "@/app/[locale]/common/utils/functions/addDataToTranslatedArray/addDataToTranslatedArray";
import {TIndustriesCardProps} from "@/app/[locale]/common/components/Industries/types";

export default function Agriculture() {
    const t = useTranslations('AgriculturePage');

    const tasksCards: TTasksCardContent[] = addDataToTranslatedArray(t.raw('tasksBlock.cardsData'), [DataMonitoringIcon, EngineIcon, RemoteManagementIcon, FuelIcon, FuelIcon], 'Icon');
    /*const productsCards: TIndustriesCardProps[] = addDataToTranslatedArray(t.raw('productsBlock.cardsData'), [slide1_products, slide2_products, slide3_products], 'image');*/
    const casesCards: TIndustriesCardProps[] = addDataToTranslatedArray(t.raw('cases.cardsData'), [slide1, slide2, slide3],'image');

    return (
        <div className={s.agriculture}>
            <Container>
                <Breadcrumbs crumb={ [t.raw('breadcrumbs.INDUSTRIES'), t.raw('breadcrumbs.AGRICULTURE')] }/>
                <TitleImageSection
                    title={t('title')}
                    image={main}
                />

                <div className={s.agriculture_tasks}>
                    <Title title={t('tasksBlock.title')}/>

                    <div className={s.agriculture_tasks_container}>
                        {
                            tasksCards.map((item: TTasksCardContent, index: number) => (
                                <TaskCard
                                    key={index}
                                    Icon={item.Icon}
                                    title={item.title}
                                />
                            ))
                        }
                    </div>
                </div>

                <div className={s.agriculture_telematics}>
                    <Title title={t('telematicsBlock.title')}/>

                    <div className={s.agriculture_telematics_cardsContainer}>
                        {
                            t.raw('telematicsBlock.cardsData').map((item: TUserCardContent, index: number) => (
                                <div key={index} className={`${s.agriculture_telematics_card} ${index % 2 === 0 ? s.agriculture_telematics_leftCards : s.agriculture_telematics_rightCards }`}>
                                    <label>{ item.title }</label>
                                    <p>{ item.description }</p>
                                </div>
                            ))
                        }
                    </div>

                    <div className={s.agriculture_telematics_bottomCard}>
                        <div className={s.agriculture_telematics_bottomCard_listContainer}>
                            <label>{ t('telematicsBlock.bottomCard.title') }</label>
                            <ul className={s.agriculture_telematics_bottomCard_list}>
                                {
                                    t.raw('telematicsBlock.bottomCard.data').map((item: string, index: number) => (
                                        <p key={index}>
                                            <span><ConfirmIcon /></span>
                                            { item }
                                        </p>
                                    ))
                                }
                            </ul>
                        </div>
                        <div className={s.agriculture_telematics_bottomCard_textContainer}>
                            <ParagraphLine className={s.agriculture_telematics_bottomCard_text}>
                                { t('telematicsBlock.bottomCard.text') }
                            </ParagraphLine>
                        </div>
                    </div>
                </div>

                <div className={s.agriculture_hardware}>
                    <Title title={t('hardwareBlock.title')} />

                    <div className={s.agriculture_hardware_imageContainer}>
                        <Image src={telematics_hardware} alt={'telematics hardware'}/>
                    </div>

                    <div className={s.agriculture_hardware_card}>
                        <label className={s.agriculture_hardware_card_label}>{ t('hardwareBlock.card.title') }</label>

                        <div className={s.agriculture_hardware_cardContainer}>
                            {
                                t.raw('hardwareBlock.card.data').map((item: TUserCardContent, index: number) => (
                                    <div key={index} className={s.agriculture_hardware_card_item}>
                                        <span><ConfirmIcon/></span>
                                        <div className={s.agriculture_hardware_card_item_content}>
                                            <label>{ item.title }</label>
                                            <p>{ item.description }</p>
                                        </div>
                                    </div>
                                ))
                            }
                        </div>
                    </div>
                </div>

                {/*<SliderBlock
                    label={t('productsBlock.title')}
                    slidesPerView={4}
                    navigationId={'products'}
                    data={productsCards}
                    card={(item, index) => (
                        <ProductsSliderCard
                            key={index}
                            label={item.label}
                            href={(item as TProductsSliderCardProps).href}
                            image={(item as TProductsSliderCardProps).image}
                        />
                    )}
                />*/}

                <SliderBlock
                    label={t('cases.title')}
                    navigationId={'cases'}
                    data={casesCards}
                    card={(item, index) => (
                        <DieselGeneratorSlideCard
                            key={index}
                            label={item.label}
                            task={(item as TDieselGeneratorSlideCardProps).task}
                            solution={(item as TDieselGeneratorSlideCardProps).solution}
                            image={(item as TDieselGeneratorSlideCardProps).image}
                        />
                    )}
                />

                <ContactUs/>
            </Container>
        </div>
    );
};